import { SyntheticEvent, forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { getBrand, createBrand } from "../../../redux/brandSlice";
import { useDispatch, useSelector } from "react-redux";
import { Button, FormControl, FormControlLabel, IconButton, MenuItem, Radio, RadioGroup, TextField } from "@mui/material";
import React from "react";
import { Brand } from "../../../model/brand.model";
import { BrandsService } from "../../../service/brands.service";
//import { isNumber } from "lodash";
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { ToastContainer, toast } from "react-toastify";
import { CustomerService } from "../../../service/customers.service";

const EnterpriseAccountDetails = forwardRef((props: any, ref: any) => {

  useImperativeHandle(ref, () => ({
    log() {
      console.log("child function");
    }
  }));

  const params = useParams();
  const brandId = params.brandid;
  const dispatch = useDispatch();
  const { brand } = useSelector((state: any) => state.brandSlice);
  const navigate = useNavigate();
  const [picture, setPicture] = useState(null);
  const [imgData, setImgData] = useState<string[]>([]);
  const [status, setStatus] = useState(1);
  const [userid, setUserid] = useState(0);
  
  

  const [hideEntFeature, sethideEntFeature] = useState(false);
  const [entfeatures, setEntfeatures] = useState(1);
  const [enterpriseName, setEnterpriseName] = useState("");
  const [enterpriseAddress,setEnterpriseAddress] = useState("");
  const [enterpriseBranch,setEnterpriseBranch] = useState("");

  const [enterpriseEIN, setEnterpriseEIN] = useState("");
  const [enterpriseGST, setEnterpriseGST] = useState("");

  const [selectedEnterpriseId, setSelectedEnterpriseId] = React.useState("");
  const [availableBrands, setAvailableBrands] = useState<Brand[]>([]);
  const customerService = new CustomerService();

  const [brandImage, setbrandImage] = useState("");
  const [brandImageData, setbrandImageData] = useState("");
  const [errMsg, setErrMsg] = useState('');
  const [isedit, setIsEdit] = React.useState(true);
  const location = useLocation();
  const [enterpriseAlias, setEnterpriseAlias] = useState("");
  // EnterpriseInfo.vcRegisteredMobile — the enterprise's own registered phone (separate from its users)
  const [enterpriseMobile, setEnterpriseMobile] = useState("");

  let parameters = {}
  let iscalled = false;
  useEffect(() => {


   // console.log("+++++++++++++++selectedBradId : " + props.empname)
    if (!iscalled) {
      iscalled = true

      
     // 
      if (props.entDetail){
        setSelectedEnterpriseId(props.entDetail.entId)
        setEnterpriseEIN(props.entDetail.EIN)

      setEnterpriseAlias(props.entDetail.entAlias)
      setStatus(props.entDetail.status)
      
      setUserid(props.entDetail.userid)

     
      sethideEntFeature(props.hideEntFeature)
   
      if (!hideEntFeature) 
        {
        setEntfeatures(props.entDetail.entFeatures)
      }

      setEnterpriseName(props.entDetail.entName)
      setEnterpriseAddress(props.entDetail.entAddress)
      setEnterpriseBranch(props.entDetail.entBranch)
      setEnterpriseGST(props.entDetail.entGST)
      // '--' is the DB placeholder for "not set" — show it as blank in the editable field
      setEnterpriseMobile((props.entDetail.entMobile && props.entDetail.entMobile !== "--") ? props.entDetail.entMobile : "")
      }

    }
  }, [props.entDetail]);

  const onChangePicture = (e: any) => {
    if (e.target.files[0]) {
      setPicture(e.target.files[0]);
      // setImgData(URL.createObjectURL(e.target.files[0]));
    }
  };


  const [submitClick, setsubmitClick] = React.useState(false);
  const [GSTInvalid, setGSTInvalid] = React.useState(false);
  const changeEntDetails = () => {

    if(!isValidGSTNo(enterpriseGST)) {
      setGSTInvalid(true)
      return      
    }

    
    if ((enterpriseEIN == "" || enterpriseEIN == null) && status == 1) {
      setsubmitClick(true)
      return
    }

    if ((enterpriseAlias == "" || enterpriseAlias == null)) {
      setsubmitClick(true)
      return
    }

    // Registered mobile is optional, but if entered it must be exactly 10 digits
    if (enterpriseMobile != "" && !/^[0-9]{10}$/.test(enterpriseMobile)) {
      toast.error("Registered mobile must be 10 digits", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2500,
        hideProgressBar: true,
      });
      return;
    }

    var einvalue = enterpriseEIN;
    if (status == 0) {
      einvalue = ""
    }

    customerService.updateEntAccountDetails(selectedEnterpriseId,userid , enterpriseEIN, enterpriseName,enterpriseAddress,enterpriseBranch,enterpriseGST,status,entfeatures,enterpriseAlias,enterpriseMobile).then((res: any) => {

      if (res != null) {
        if (res.status == 100) {
          toast.success(res.msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
            hideProgressBar: true,
          });

        } else {

          toast.error(res.msg, {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
            hideProgressBar: true,
          });

        }

        props.callback();
      }

    }).catch((err: any) => {
      console.log('err ', err);
      setErrMsg('Something went wrong ');
    });

  }

  const onUploadBrandImg = (event: SyntheticEvent) => {
    const element = event.target as HTMLInputElement;
    if (element.files) {

      const file = element.files[0];
      console.log("^^^Cad^^^^^^^^^^^file : " + file.name);
      const reader = new FileReader()
      reader.readAsDataURL(file)
      reader.onload = () => {

        setbrandImage(file.name);

        setbrandImageData(reader.result as string);

      }
      reader.onerror = (e) => { console.log('err') }
    }
  }

  function isValidGSTNo(str:any) {
   
    // Regex to check valid
    // GST CODE
    let regex = new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/);
 
    // GST CODE
    // is empty return false
    if (str == null) {
        return false;
    }
 
    // Return true if the GST_CODE
    // matched the ReGex
    if (regex.test(str) == true) {
        return true;
    }
    else {
        return false;
    }
}


  return (
    <div className="">


      <div className="border p-3">

        

       <div className="row">


     
          <div className="col-md-6  text-left">
            <div className="form-group   font_size_13px mt-1">

              <TextField size="small" label="EIN" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 30 } }}
                type="text" className="form-control" name='Ein' value={enterpriseEIN}
                error={submitClick}
                //  helperText={ (submitClick &&   (brandName == "" || brandName == null)) ? 'required*' : ""}


                onChange={(e: any) => {
                  setEnterpriseEIN(e.target.value)
                }}
              />
            </div>

            

            
          </div>

          <div className="col-md-6 text-left">
            <div className="form-group  font_size_13px mt-1">

              <TextField size="small" label="Alias Name" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 30 } }}
                type="text" className="form-control" name='Alias Name' value={enterpriseAlias}
                error={submitClick}
                //  helperText={ (submitClick &&   (brandName == "" || brandName == null)) ? 'required*' : ""}


                onChange={(e: any) => {
                  setEnterpriseAlias(e.target.value)
                }}
              />
            </div>
          </div>
          </div>
          <div className="row">
          <div className="col-md-6 text-left">
            <div className="form-group  font_size_13px mt-1">

              <TextField size="small" label="Ent Name" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 30 } }}
                type="text" className="form-control" name='EntName' value={enterpriseName}
                error={submitClick}
                //  helperText={ (submitClick &&   (brandName == "" || brandName == null)) ? 'required*' : ""}


                onChange={(e: any) => {
                  setEnterpriseName(e.target.value)
                }}
              />
            </div>
          </div>

          <div className="col-md-6 text-left">
            <div className="form-group  font_size_13px mt-1">

              <TextField size="small" label="Ent Address" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 30 } }}
                type="text" className="form-control" name='EntAddr' value={enterpriseAddress}
                error={submitClick}
                //  helperText={ (submitClick &&   (brandName == "" || brandName == null)) ? 'required*' : ""}


                onChange={(e: any) => {
                  setEnterpriseAddress(e.target.value)
                }}
              />
            </div>
          </div>
          </div>
          <div className="row">
          <div className="col-md-6 text-left">
            <div className="form-group  font_size_13px mt-1">

              <TextField size="small" label="Ent Branch" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 30 } }}
                type="text" className="form-control" name='EntBranch' value={enterpriseBranch}
                error={submitClick}
                //  helperText={ (submitClick &&   (brandName == "" || brandName == null)) ? 'required*' : ""}


                onChange={(e: any) => {
                  setEnterpriseBranch(e.target.value)
                }}
              />
            </div>
          </div>

          <div className="col-md-6 text-left">
            <div className="form-group  font_size_13px mt-1">

              <TextField size="small" label="Ent GST" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 30 } }}
                type="text" className="form-control" name='EntGst' value={enterpriseGST}
                error={submitClick || GSTInvalid}
                //  helperText={ (submitClick &&   (brandName == "" || brandName == null)) ? 'required*' : ""}

               
                onChange={(e: any) => {
                  setEnterpriseGST(e.target.value)
                }}
              />
            </div>
          </div>
          </div>
          <div className="row">
          <div className="col-md-6 text-left">
            <div className="form-group  font_size_13px mt-1">

              <TextField size="small" label="Registered Mobile" InputLabelProps={{ shrink: true }} InputProps={{ sx: { height: 30 } }}
                type="text" className="form-control" name='EntMobile' value={enterpriseMobile}
                helperText="10 digits — the enterprise's registered contact number"


                onChange={(e: any) => {
                  setEnterpriseMobile(e.target.value.replace(/[^0-9]/g, '').slice(0, 10))
                }}
              />
            </div>
          </div>
          </div>
          <div className="col-md-8 text-left">
            <div className="form-group"  >
            <label className="mt-2 ml-1 pr-3" style={{width:'100px'}} >User Status</label>
              <FormControl className="" >
                <RadioGroup row name='status' value={status} className="mt-0 p-0"
                  onChange={(e) => {
                    setStatus(Number(e.target.value))

                  }} >

                  <FormControlLabel hidden value="-1" label="Pending" control={<Radio size="small" color="success" />} />
                  <FormControlLabel value="1" label="Activate" control={<Radio size="small" color="success" />} />
                  <FormControlLabel value="0" label="Deactive" control={<Radio size="small" color="error" />} />
                </RadioGroup>
              </FormControl>
            </div>
          </div>

            {!hideEntFeature && 
          <div className="col-md-12 text-left ">

            <div className="form-group">
            <div className="row-md-12">
            <label className="mt-2 ml-1 pr-3" style={{width:'100px'}}  >Ent Features</label>

              <FormControl className="" >
                <RadioGroup row={false} name='entfeatures' value={entfeatures} className="mt-0 p-0"
                  onChange={(e) => {
                    setEntfeatures(Number(e.target.value))

                  }} >

                  <FormControlLabel hidden value="-1" label="Pending" control={<Radio size="small" color="success" />} />
                  <FormControlLabel value="1" label="Activate(with stock status)" control={<Radio size="small" color="success" />} />
                  <FormControlLabel value="2" label="Activate(without stock status)" control={<Radio size="small" color="success" />} />
                  <FormControlLabel value="0" label="Deactive" control={<Radio size="small" color="error" />} />
                </RadioGroup>
              </FormControl>
              </div>
            </div>
          </div>
          }

       
      </div>
      <div className="col-12 text-right mt-3">
        {/* <Button  onClick={() => changeEntStatus()} >  */}

        <Button style={{ color: "green" }} className="mr-2" onClick={() => changeEntDetails()} variant="text" 
        startIcon={<ArrowUpwardRoundedIcon />}>
          Submit
        </Button>

      </div>




    </div>
  );
})

export default EnterpriseAccountDetails;
